export default class DateTime {
  private static readonly monthsGenitive = [
    "stycznia",
    "lutego",
    "marca",
    "kwietnia",
    "maja",
    "czerwca",
    "lipca",
    "sierpnia",
    "września",
    "października",
    "listopada",
    "grudnia",
  ];

  /**
   * Returns date in format: 12 paździenika
   */
  public static dateInWords(date: Date): string {
    const day: number = date.getDate();
    const month: string = this.monthsGenitive[date.getMonth()];

    return `${day} ${month}`;
  }

  /**
   * Check if two dates are on the same day
   */
  public static datesOnSameDay(first: Date, second: Date): boolean {
    return (
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate()
    );
  }

  /**
   * Returns date in format: 12 paździenika 9:45
   */
  public static fullDateTime(date: Date) {
    return `${this.dateInWords(date)} ${this.time(date)}`;
  }

  /**
   * Returns time in format: 9:45
   */
  public static time(date: Date): string {
    return `${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`;
  }

  /**
   * Returns time with or without date depending on how much time has passed
   */
  public static adaptiveDateTime(date: Date): string {
    const today: Date = new Date();
    const isToday = this.datesOnSameDay(date, today);
    const yesterday: Date = new Date();
    yesterday.setDate(new Date().getDate() - 1);
    const isYesterday = this.datesOnSameDay(date, yesterday);

    if (isToday) {
      return this.time(date);
    } else if (isYesterday) {
      return `wczoraj ${this.time(date)}`;
    } else {
      return this.fullDateTime(date);
    }
  }

  /**
   * Returns date or days remaining
   */
  public static daysAgo(date: string | Date, today: Date = new Date()) {
    const diff = this.daysDiff(today, date);

    if (diff === 0) {
      return "dzisiaj";
    } else if (diff === 1) {
      return "wczoraj";
    } else if (diff <= 30) {
      return `${diff} dni temu`;
    } else {
      return this.fullDateTime(new Date(date));
    }
  }

  /**
   * Returns difference in two dates expressed in days
   */
  public static daysDiff(date1: Date | string, date2: Date | string): number {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);
    const msInDay = 24 * 60 * 60 * 1000;

    firstDate.setHours(0, 0, 0, 0);
    secondDate.setHours(0, 0, 0, 0);

    return Math.round(Math.abs(firstDate.getTime() - secondDate.getTime()) / msInDay);
  }
}
